module.exports = __webpack_public_path__ + "static/media/icon-bar-chart.4a50dbe9.svg";